import { useQuery } from '@api/hooks'
import { Box, Paper, Skeleton, Stack, Typography } from '@mui/material'
import MarketBasketsApi, { MarketBasketsKeys } from '@services/marketBaskets.api'
import { useParams } from 'react-router-dom'

export default function ProductDetails() {
	const { marketBasketId, similarProductId } = useParams()

	const { data: product, isLoading } = useQuery({
		queryKey: MarketBasketsKeys.similarProduct({
			marketBasketId,
			productId: similarProductId,
		}),
		queryFn: () =>
			MarketBasketsApi.similarProduct({
				marketBasketId,
				productId: similarProductId,
			}),
	})

	return (
		<Stack spacing={2} sx={{ width: '100%' }}>
			<Paper variant="outlined" sx={{ padding: '1rem', width: '100%' }}>
				<Stack spacing={4} direction="row" alignItems="center">
					<Property label="Product" value={product?.description} loading={isLoading} />
					<Property label="Manufacturer" value={product?.manufacturerName} loading={isLoading} />
					<Property
						label="MFG PROD DMID"
						value={`${product?.beplManufacturerProductItemId}`}
						loading={isLoading}
					/>
				</Stack>
			</Paper>
		</Stack>
	)
}

function Property({ label, value, loading }: { label: string; value: string; loading: boolean }) {
	return (
		<Stack direction="row" gap={1}>
			<Box>
				<Typography color="text.primary">{label}</Typography>
			</Box>
			<Typography color="text.secondary">{loading ? <Skeleton width="8rem" /> : value}</Typography>
		</Stack>
	)
}
